import { Playground, Props } from 'docz';
import { LoadingLine } from '@cosmotech/ui';
import * as dataLoading from "../../../../../../assets/loadingLine/dataLoading.json";
import * as dataLoaded from "../../../../../../assets/loadingLine/dataLoaded.json";
import * as dataError from "../../../../../../assets/loadingLine/dataError.json";
import * as React from 'react';
export default {
  Playground,
  Props,
  LoadingLine,
  dataLoading,
  dataLoaded,
  dataError,
  React
};